/**
 * Decodes a widget theme image ahead of paint (KRA-427). Resolves `false` rather than rejecting: an
 * image that fails is the bundled fill, not an error. Its own module so the store's tests can mock it —
 * jsdom has no real image loading.
 */
export function preloadThemeImage(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();

    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = url;
  });
}
